import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import BaseInput from "../../../toolkit/baseInput";
import { Alert, Button, FormGroup, Label, Input, Col, Row } from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import s from "./styles.scss";
import Reform from "@franleplant/reform";
import { FormErrors } from "@franleplant/reform/types";
import { connect } from "react-redux";
import { CuentaContable } from "../../../types/CuentaContable";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  creatingCuentaContable: boolean;
  history: any;
  client: any;
  editCuentaContable: (
    cuentaContableId: string,
    cuentaContable: CuentaContable
  ) => any;
  creatingCuentaContableError: object;
  cuentasContables: CuentaContable[];
  createCuentaContable: (fields: object) => any;
  cuentaContableCreated: boolean;
  cuentaContableToEdit: CuentaContableToEdit;
  disableCuentaContableCreated: () => {};
  catalogoCuentasContables: CuentaContable[];
}

interface CuentaContableToEdit {
  cuentaContableId: string;
  nombre: string;
  numeroCuenta: string;
  activo: boolean;
}

interface State {
  fields: CuentaContable;
  editing: boolean;
  errors: FormErrors;
  selected: any;
}

const getCleanFields = () => {
  return {
    nombre: "",
    numeroCuenta: "",
    activo: true
  };
};

class CreateCuentaContableModal extends React.Component<Props, State> {
  state = {
    fields: getCleanFields(),
    editing: false,
    errors: {},
    selected: null
  };

  re = Reform.reactMixins.objectMixin(this);

  validationRules = {
    nombre: {
      required: true,
      maxLength: 200,
      validateNombre: value => this.nombreValidation(value)
    },
    numeroCuenta: {
      required: true,
      maxLength: 50,
      validateNombre: value => this.nombreValidation(value)
      //shortKeyExistence: value => this.validateShortKeyExistence(value)
    }
  };

  validationMessages = {
    required: _ => `Obligatorio`,
    minLength: ruleValue => `Debe tener al menos ${ruleValue} caracteres`,
    maxLength: ruleValue => `Deber tener máximo ${ruleValue} caracteres`,
    default: _ => `Inválido`,
    shortKeyExistence: ruleValue =>
      `Este numero de cuenta ya existe, modifiquelo.`,
    validateNombre: ruleValue => `Deber escribir caracteres alfanumericos`
  };

  nombreValidation = value => {
    const exp = /^[a-zA-Z0-9-/ ]+$/;
    return exp.exec(value) == null ? true : false;
  };

  validateShortKeyExistence = value => {
    let valid = false;
    this.props.catalogoCuentasContables.forEach(club => {
      if (club.numeroCuenta == value)
        valid =
          this.props.cuentaContableToEdit &&
          this.props.cuentaContableToEdit.numeroCuenta == value
            ? false
            : true;
    });
    return valid;
  };

  componentDidUpdate() {
    if (!this.props.isOpen && this.state.editing) {
      this.setState(prevState => {
        return {
          ...prevState,
          fields: getCleanFields(),
          editing: false
        };
      });
    }
    if (this.props.isOpen && !this.state.editing) {
      let fields;
      if (this.props.cuentaContableToEdit) {
        const cuentaContableToEdit = this.props.cuentaContableToEdit;
        fields = {
          ...this.state.fields,
          ...cuentaContableToEdit
        };
      } else {
        fields = getCleanFields();
      }
      this.setState(prevState => {
        return {
          ...prevState,
          fields,
          editing: true,
          errors: {}
        };
      });
    }
  }

  onChangeFactory = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const fields = {
          ...state.fields,
          [fieldName]: value
        };

        return { ...state, error: {}, fields };
      });
      this.re.validateField(fieldName, value);
    };
  };

  onSubmit = e => {
    e.preventDefault();
    if (this.re.validateFormFromState()) {
      if (this.props.cuentaContableToEdit) {
        this.props.editCuentaContable(
          this.props.cuentaContableToEdit &&
            this.props.cuentaContableToEdit.cuentaContableId,
          this.state.fields
        );
      } else {
        this.props.createCuentaContable(this.state.fields);
      }
    }
  };

  render() {
    return (
      <ModalFrame
        title={`${
          this.props.cuentaContableToEdit ? "Editar" : "Crear"
        } Cuenta Contable`}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="lg"
      >
        <div className={s.modalContainer}>
          <div className="h-100">
            <form className={s.basicDataClub}>
              <div className="form-row">
                <div className="col">
                  <BaseInput
                    label={"Nombre"}
                    name="nombre"
                    type="text"
                    id="nombre"
                    placeholder="Nombre"
                    value={this.state.fields.nombre}
                    onChange={this.onChangeFactory("nombre")}
                    errors={this.re.mapFieldErrors("nombre")}
                  />
                </div>
                <div className="col">
                  <BaseInput
                    label={"Numero de cuenta"}
                    name="numeroCuenta"
                    type="text"
                    id="numeroCuenta"
                    placeholder="Numero de cuenta"
                    value={this.state.fields.numeroCuenta}
                    onChange={this.onChangeFactory("numeroCuenta")}
                    errors={this.re.mapFieldErrors("numeroCuenta")}
                  />
                </div>
                <div className="col">
                  <div className={s.checkboxContainer}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          disabled="true"
                          checked={this.state.fields.activo}
                        />{" "}
                        Activo
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className={s.formGroup}>
            <div className="row">
              <div className="col" />
              <div className="col-2">
                <Button
                  className={`${s.buttonMarginTop} ${s.primaryButton}`}
                  onClick={e => this.onSubmit(e)}
                  size="sm"
                  block
                  disabled={
                    this.props.creatingCuentaContable ||
                    !this.state.fields.numeroCuenta ||
                    this.re.mapFieldErrors("numeroCuenta").length > 0 ||
                    !this.state.fields.nombre ||
                    this.re.mapFieldErrors("nombre").length > 0
                  }
                >
                  {"Guardar"}
                </Button>
              </div>
            </div>
          </div>
          {this.props.creatingCuentaContableError && (
            <span>
              <hr />
              <Alert color="danger">
                Ocurrio un error creando la Cuenta Contable. Intente nuevamente.
              </Alert>
            </span>
          )}
        </div>
      </ModalFrame>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(s)(CreateCuentaContableModal))
);
